import _find from 'lodash/find';
import _camelCase from 'lodash/camelCase';
import { LOCALES } from "../../constants/index.js";
/**
 * format country
 */
export function formatCountry(country) {
  var enLabel = _find(country.Label, function (item) {
    return _camelCase(item.Locale) === _camelCase(LOCALES.EN);
  });
  var arLabel = _find(country.Label, function (item) {
    return _camelCase(item.Locale) === _camelCase(LOCALES.AR);
  });
  return {
    code: country.Code,
    dialCode: country.DialCode,
    labelData: country.Label,
    label: (enLabel === null || enLabel === void 0 ? void 0 : enLabel.Value) + " (" + country.DialCode + ")",
    arLabel: (arLabel === null || arLabel === void 0 ? void 0 : arLabel.Value) + " (" + country.DialCode + ")"
  };
}